(function() {
	angular.module('ShargoApp')
		.service('DriverProfileService', function ($http, $q, Configuration, AuthService) {
			var svc = {};

			svc.getInfo = function() {
				return $http.get(Configuration.apiUrl + '/drivers/me', {
					headers: {
						'x-token': localStorage.getItem('xtoken'),
						'x-userid': localStorage.getItem('userid')
					}
				});
			};

			svc.getStatistics = function (type) {
				return $http.get(Configuration.apiUrl + '/drivers/me/info?type=' + type, {
					headers: {
						'x-token': localStorage.getItem('xtoken'),
						'x-userid': localStorage.getItem('userid')
					}
				});
			};

			svc.getInvoices = function () {
				return $http.get(Configuration.apiUrl + '/drivers/invoices', {
					headers: {
						'x-token': localStorage.getItem('xtoken'),
						'x-userid': localStorage.getItem('userid')
					}
				});
			};

            svc.uploadAvailabilityMatrix = function (newAvailability) {
                return $http.post(Configuration.apiUrl + '/v2/drivers/availability',
					{
						driver: localStorage.getItem('userid'),
						availability: newAvailability
					},
					{
                    headers: {
                        'x-token': localStorage.getItem('xtoken'),
                        'x-userid': localStorage.getItem('userid')
                    }
                });
            };

            svc.getAvailability = function () {
                return $http.get(Configuration.apiUrl + '/v2/drivers/availability', {
                    headers: {
                        'x-token': localStorage.getItem('xtoken'),
                        'x-userid': localStorage.getItem('userid')
                    }
                });
            };

			svc.downloadInvoice = function (invoice) {
                console.log("downloadInvoice! ", invoice);
                var id = invoice._id;
                var supportsDownloadAttribute = 'download' in document.createElement('a');
                var invoiceName = 'Factura-M' + invoice.month + '-' + invoice.year + '.pdf';
                var win;

                if(!supportsDownloadAttribute) {
                    win = $window.open('about:blank', invoiceName);
                }
                $window.location.href = "http://"+invoice.url;
			};

			svc.updateInfoDriver = function (params) {
				return $http.put(Configuration.apiUrl + '/drivers', params, {
					headers: {
						'x-token': localStorage.getItem('xtoken'),
						'x-userid': localStorage.getItem('userid')
					}
				});
			};

			svc.updatePassDriver = function(params) {
				return $http.post(Configuration.apiUrl + '/drivers/password/change', params, {
					headers: {
						'x-token': localStorage.getItem('xtoken'),
						'x-userid': localStorage.getItem('userid')
					}
				});
			};

			svc.driverLogout = function () {
				var deferred = $q.defer();
				$http.get(Configuration.apiUrl + '/auth/signout', {
					headers: {
						'x-token': localStorage.getItem('xtoken'),
						'x-userid': localStorage.getItem('userid')
					}
				})
					.then(function () {
						AuthService.logout();
						deferred.resolve();
					})
					.catch(function () {
						AuthService.logout();
						deferred.reject();
					});
				return deferred.promise;
			};

			return svc;
		})

		.controller('DriverProfileController', function ($scope, $rootScope, $window, $timeout, $filter, DriverProfileService, toolsService, LocaleCfgs, Configuration) {
			$rootScope.pageConfiguration = {
				footer: false,
				header: {
					solid: -1000,
					background: 'linear-gradient(to bottom, #585757, #4a4a4a)',
					preheader: false,
					headerLink: false,
					headerLogo: Configuration.siteDomain + "/img/header/shargo-orange.svg",
					logIn: false,
					dashboard: false,
					callToAction: {
						link: false,
						text: '',
						target: '',
						hide: false,
						disabled: false
					},
					profile: false
				}
			};
			/*  --VARIABLES--  */
			var previousPhone = "";
			var selectedInvoice = 0;
			$scope.toolsService = toolsService;
			$scope.info = {};
			$scope.availabilityHeaders = [];
			for (var hour = 9; hour < 23; ++hour) {
				$scope.availabilityHeaders.push(hour.toString()+":00");
				$scope.availabilityHeaders.push(hour.toString()+":30");
			}

            $scope.days = [
            	"driver-profile.availability.monday",
				"driver-profile.availability.tuesday",
				"driver-profile.availability.wednesday",
				"driver-profile.availability.thursday",
				"driver-profile.availability.friday",
				"driver-profile.availability.saturday",
				"driver-profile.availability.sunday"
			];

			$scope.showSuccessSave = false;
			$scope.availability = [
                [
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                [
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                [
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                [
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                [
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                [
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                [
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ]
            ];
			$scope.statistics = { type: "weekly" };
			$scope.invoices = [];
			$scope.form = {
				fiscal: {
					show: false,
					error: {
						owner: false,
						number: false
					},
					owner: "",
					number: ""
				},
				info: {
					show: false,
					showPass: false,
					error: {
						name: false,
						phone: false,
						uid: false,
						actPass: false,
						newPass: false,
						againNewPass: false
					},
					name: "",
					phone: "",
					uid: "",
					actPass: "",
					newPass: "",
					againNewPass: ""
				},
				picture: {
					show: false,
					error: {
						image: false
					},
					uploading: false,
					image: "",
					dropImage: ""
				}
			};


			/*  --FUNCTIONS--  */
			function updateInfo() {
				DriverProfileService.getInfo()
					.then(function (response) {
						$scope.info = {
							picture: response.data.imageUrl,

							name: response.data.firstName + " " + response.data.lastName,
							email: response.data.email,
							phone: response.data.phone,
							uid: response.data.uid,
							bancAccountOwner: response.data.payment.bancAccountOwner,
							bancAccountNumber: response.data.payment.bancAccountNumber,
							ratingAvg: response.data.ratingAvg ? response.data.ratingAvg.toFixed(2) : 0,
							numRatings: response.data.ratingAvg ? response.data.numRatings : 0
						};
					})
					.catch(function (response) {
						console.log("GET INFO FAIL", response);
					});
			}

			function updateStatistics() {
				DriverProfileService.getStatistics($scope.statistics.type)
					.then(function (response) {
						$scope.statistics = {
							type: $scope.statistics.type,
							numDeliveries: response.data.numDeliveries,
							numPackages: response.data.numPackages,
							incomes: response.data.income.toFixed(2),
							distance: (response.data.distance/1000).toFixed(2)
						};
					})
					.catch(function (response) {
						console.log("GET STATISTICS FAIL", response);
					});
			}

			function updateAvailability(i, j) {
				$scope.availability[i][j] = ($scope.availability[i][j] + 1)%3;
                $scope.availabilityChanged = true;
			}
			$scope.availabilityChanged = false;
			$scope.updateAvailability = updateAvailability;

			function uploadAvailability() {

			}
            $scope.uploadAvailability = uploadAvailability;

			function updateInvoices() {
				DriverProfileService.getInvoices()
					.then(function (response) {
						$scope.invoices = response.data;
						for (var i = 0; i < $scope.invoices.length; ++i) {
							if ($scope.invoices[i]) {
								$scope.invoices[i].type = "PDF";
								$scope.invoices[i].fromDay = $scope.invoices[i].fromDay.toString().length < 2 ? '0'+$scope.invoices[i].fromDay : $scope.invoices[i].fromDay;
								$scope.invoices[i].toDay = $scope.invoices[i].toDay.toString().length < 2 ? '0'+$scope.invoices[i].toDay : $scope.invoices[i].toDay;
								$scope.invoices[i].fromMonth = LocaleCfgs.shortMonths[$scope.invoices[i].fromMonth];
								$scope.invoices[i].toMonth = LocaleCfgs.shortMonths[$scope.invoices[i].toMonth];

								var name = $filter('translate')('driver-profile.invoices.invoice') + ' ' + $scope.invoices[i].fromDay;
								if ($scope.invoices[i].fromMonth !== $scope.invoices[i].toMonth) {
									name += ' ' + $filter('translate')($scope.invoices[i].fromMonth);
								}
								if ($scope.invoices[i].fromYear !== $scope.invoices[i].toYear) {
									name += ' ' + $scope.invoices[i].fromYear;
								}
								name += '-' + $scope.invoices[i].toDay + ' ' + $filter('translate')($scope.invoices[i].toMonth) + ' ' + $scope.invoices[i].toYear;
								$scope.invoices[i].name = name;
                            }
						}
						if ($scope.invoices.length === 0) {
							$scope.invoices = [0, 1, 2];
						}
					})
					.catch(function (response) {
						console.log("GET INVOICES FAIL", response);
						$scope.invoices = [0, 1, 2];
					});
			}
			
			function selectInvoice(index) {
				$scope.invoices[selectedInvoice].selected = false;
				$scope.invoices[index].selected = true;
				selectedInvoice = index;
				console.log('selected invoice url', $scope.invoices[selectedInvoice].url);
				$window.location.href = 'https://' + $scope.invoices[selectedInvoice].url;
                //$window.open($scope.invoices[selectedInvoice].url, "_blank");
				/*
                DriverProfileService.downloadInvoice($scope.invoices[index]._id)
					.then(function (response) {
						var id = $scope.invoices[index]._id;
						var supportsDownloadAttribute = 'download' in document.createElement('a');
						var invoiceName = $scope.invoices[index].name;
						var win;

						if(!supportsDownloadAttribute) {
							win = $window.open('about:blank', invoiceName);
						}

						var data = response.data;
						var blob = new Blob([data], { type:"application/pdf" });
						if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
							console.log("downloadInvoice > IE case");
							window.navigator.msSaveOrOpenBlob(blob, invoiceName);
						} else if(!supportsDownloadAttribute) { // Safari
							console.log("downloadInvoice > Safari case");
							win.location = window.URL.createObjectURL(blob);
						} else { // Chrome, Firefox, Brave
							console.log("downloadInvoice > other browsers case");
							var anchor = angular.element('<a/>');
							var oneAnchor = anchor.attr({
								id: 'invoice-link-'+ id,
								href: window.URL.createObjectURL(blob),
								target: '_blank',
								download: invoiceName
							})[0];
							document.body.appendChild(oneAnchor);
							$timeout(function () {
								oneAnchor.click();
								document.body.removeChild(oneAnchor);
							});
						}
					})
					.catch(function (response) {
						console.log("DOWNLOAD INVOICE FAIL", response);
					});
                */
			}

			function switchStatistics(type) {
				$scope.statistics.type = type;
				updateStatistics();
			}

			function logout() {
				DriverProfileService.driverLogout()
					.then(function () {
						$rootScope.isUserLogged = false;
						$scope.newUser = {};
						$window.location.href = '/';
					})
					.catch(function () {
						$rootScope.isUserLogged = false;
						$scope.newUser = {};
						$window.location.href = '/';
					});
			}

			function activeFiscal() {
				toolsService.setFalse($scope.form.fiscal.error);
				$scope.form.fiscal.owner = $scope.info.bancAccountOwner;
				$scope.form.fiscal.number = $scope.info.bancAccountNumber;

				$scope.form.fiscal.show = $rootScope.blur.driverProfileFiscal = $rootScope.blur.driverProfileFiscalForced = true;
			}

			function cancelFiscal() {
				$scope.form.fiscal.show = $rootScope.blur.driverProfileFiscal = $rootScope.blur.driverProfileFiscalForced = false;
			}

			function clickOutFiscal() {
				if ($scope.form.fiscal.show) {
					$scope.form.fiscal.show = $rootScope.blur.driverProfileFiscal = $rootScope.blur.driverProfileFiscalForced;
					$rootScope.blur.driverProfileFiscalForced = false;
				}
			}

			function uploadAvailabilityDriver() {

                DriverProfileService.uploadAvailabilityMatrix($scope.availability)
                    .then(function (response) {
						console.log("Update availability response", response)
                        $scope.showSuccessSave = true;
						setTimeout(function() {
							console.log("TIMEOUT");
                            $scope.showSuccessSave = false;
						}, 2000);
                    })
                    .catch(function (response) {
                        console.log("SUBMIT AVAILABILITY FAIL", response);
                    });
			}

            function downloadAvailabilityDriver() {
                DriverProfileService.getAvailability()
                    .then(function (response) {
                        console.log("Download availability response", response);
						$scope.availability = response.data.availability;
                    })
                    .catch(function (response) {
                        console.log("DOWNLOAD AVAILABILITY FAIL", response);
                    });
            }

			function submitFiscal() {
				if ($scope.form.fiscal.owner && $scope.form.fiscal.number) {
					if (!IBAN.isValid($scope.form.fiscal.number)) {
						$scope.form.fiscal.error.number = "driver-profile.errors.bancAccountNumber";
					}
					else {
						var params = {
							payment: {
								bancAccountOwner: $scope.form.fiscal.owner,
								bancAccountNumber: $scope.form.fiscal.number
							}
						};
						DriverProfileService.updateInfoDriver(params)
							.then(function (response) {
								updateInfo();
								$scope.form.fiscal.show = $rootScope.blur.driverProfileFiscal = $rootScope.blur.driverProfileFiscalForced = false;
							})
							.catch(function (response) {
								console.log("SUBMIT FISCAL FAIL", response);
								$scope.form.fiscal.error.owner = response.data.message;
							});
					}
				}
				else {
					if (!$scope.form.fiscal.owner) {
						$scope.form.fiscal.error.owner = "driver-profile.errors.bancAccountOwner";
					}
					if (!$scope.form.fiscal.number) {
						$scope.form.fiscal.error.number = "driver-profile.errors.bancAccountNumber";
					}
				}
			}

			function activeInfo() {
				toolsService.setFalse($scope.form.info.error);
				$scope.form.info.name = $scope.info.name;
				$scope.form.info.phone = $scope.info.phone;
				$scope.form.info.uid = $scope.info.uid;
				$scope.form.info.actPass = $scope.form.info.newPass = $scope.form.info.againNewPass = '';

				$scope.form.info.show = $rootScope.blur.driverProfileInfo = $rootScope.blur.driverProfileInfoForced = true;
			}

			function cancelInfo() {
				$scope.form.info.show = $scope.form.info.showPass = $rootScope.blur.driverProfileInfo = $rootScope.blur.driverProfileInfoForced = false;
			}

			function clickOutInfo() {
				if ($scope.form.info.show) {
					if ($scope.form.info.showPass) {
						$scope.form.info.showPass = $rootScope.blur.driverProfileInfoForced;
					}
					$scope.form.info.show = $rootScope.blur.driverProfileInfo = $rootScope.blur.driverProfileInfoForced;
					$rootScope.blur.driverProfileInfoForced = false;
				}
			}

			function submitInfo() {
				if ($scope.form.info.name && $scope.form.info.phone && $scope.form.info.uid) {
					var params = {
						firstName: $scope.form.info.name,
						phone: $scope.form.info.phone,
						uid: $scope.form.info.uid
					};
					DriverProfileService.updateInfoDriver(params)
						.then(function (response) {
						})
						.catch(function (response) {
							console.log("SUBMIT INFO FAIL", response);
							$scope.form.info.error.name = response.data.message;
						})
						.finally(function () {
							if ($scope.form.info.showPass) {
								if ($scope.form.info.actPass && $scope.form.info.newPass && $scope.form.info.newPass === $scope.form.info.againNewPass) {
									var passParams = {
										currentPassword: $scope.form.info.actPass,
										newPassword: $scope.form.info.newPass
									};
									DriverProfileService.updatePassDriver(passParams)
										.then(function (response) {
											updateInfo();
											$scope.form.info.show = $scope.form.info.showPass = $rootScope.blur.driverProfileInfo = $rootScope.blur.driverProfileInfoForced = false;
										})
										.catch(function (response) {
											console.log("SUBMIT PASS FAIL", response);
											$scope.form.info.error.actPass = response.data.message;
										})
								}
								else {
									if (!$scope.form.info.actPass) {
										$scope.form.info.error.actPass = "driver-profile.errors.actPass";
									}

									if (!$scope.form.info.newPass) {
										$scope.form.info.error.newPass = "driver-profile.errors.newPass";
									}

									if (!$scope.form.info.againNewPass) {
										$scope.form.info.error.againNewPass = "driver-profile.errors.againNewPass";
									}
									if ($scope.form.info.newPass !== $scope.form.info.againNewPass) {
										$scope.form.info.error.newPass = "driver-profile.errors.pass-not-match";
									}
								}
							}
							else {
								if (!$scope.form.info.error.name) {
									updateInfo();
									$scope.form.info.show = $rootScope.blur.driverProfileInfo = $rootScope.blur.driverProfileInfoForced = false;
								}
							}
						});
				}
				else {
					if (!$scope.form.info.name) {
						$scope.form.info.error.name = "driver-profile.errors.name";
					}
					if (!$scope.form.info.phone) {
						$scope.form.info.error.phone = "driver-profile.errors.phone";
					}
					if (!$scope.form.info.uid) {
						$scope.form.info.error.uid = "driver-profile.errors.uid";
					}
				}
			}

			function activePicture() {
				toolsService.setFalse($scope.form.picture.error);
				$scope.form.picture.uploading = false;
				$scope.form.picture.image = "";
				$scope.form.picture.dropImage = "";

				$scope.form.picture.show = $rootScope.blur.driverProfilePicture = $rootScope.blur.driverProfilePictureForced = true;
			}

			function cancelPicture() {
				$scope.form.picture.show = $rootScope.blur.driverProfilePicture = $rootScope.blur.driverProfilePictureForced = false;
			}

			function clickOutPicture() {
				if ($scope.form.picture.show) {
					$scope.form.picture.show = $rootScope.blur.driverProfilePicture = $rootScope.blur.driverProfilePictureForced;
					$rootScope.blur.driverProfilePictureForced = false;
				}
			}

			function submitPicture() {
				$scope.form.picture.uploading = true;
				if (!$scope.form.picture.error.image) {
					if ($scope.form.picture.dropImage) {
						if ($scope.form.picture.dropImage.base64.indexOf(';base64,') > -1) {
							$scope.form.picture.image.base64 = $scope.form.picture.dropImage.base64.substring($scope.form.picture.dropImage.base64.indexOf(';base64,') + 8);
						}
						else {
							$scope.form.picture.error.image = "driver-profile.form.image.image-error-1";
							$scope.form.picture.uploading = $scope.form.picture.image = $scope.form.picture.dropImage = false;
						}
					}
					var params = {
						profileImageData: $scope.form.picture.image.base64
					};
					DriverProfileService.updateInfoDriver(params)
						.then(function successCallback(response) {
							$scope.form.picture.show= $rootScope.blur.driverProfilePicture = $rootScope.blur.driverProfilePictureForced = false;
							toolsService.setFalse($scope.form.picture.error);
							$scope.form.picture.uploading = false;
							updateInfo();
						})
						.catch(function errorCallback(response) {
							console.log("FAIL IMAGE", response);
							$scope.form.picture.uploading = false;
							$scope.form.picture.error.image = "driver-profile.form.image.image-error-1";
							$scope.form.picture.image = $scope.form.picture.dropImage = false;
						});
				}
				else {
					$scope.form.picture.uploading = false;
					$scope.form.picture.error.image = "driver-profile.form.image.image-error-1";
					$scope.form.picture.image = $scope.form.picture.dropImage = false;
				}
			}

			function checkPhone() {
				if (!/^[0-9]*$/.test($scope.form.info.phone)) {
					$scope.form.info.phone = previousPhone;
				}
				else {
					previousPhone = $scope.form.info.phone;
				}
			}

			 function checkImage(item) {
				 $scope.form.picture.error.image = false;
				 if ($scope.form.picture[item].filetype.indexOf('image') < 0) {
					 $scope.form.picture.error.image = "driver-profile.form.image.image-error-1";
					 $scope.form.picture.uploading = $scope.form.picture.image = $scope.form.picture.dropImage = false;
				 }
				 else if ($scope.form.picture[item].filesize > 2097152) {
					 $scope.form.picture.error.image = "driver-profile.form.image.image-error-2";
					 $scope.form.picture.uploading = $scope.form.picture.image = $scope.form.picture.dropImage = false;
				 }
			 }


			/*  --EXECUTION--  */
			updateInfo(); updateStatistics(); updateInvoices(); downloadAvailabilityDriver();

			$scope.switchStatistics = switchStatistics;
			$scope.logout = logout;
			$scope.activeFiscal = activeFiscal;
			$scope.cancelFiscal = cancelFiscal;
			$scope.clickOutFiscal = clickOutFiscal;
			$scope.submitFiscal = submitFiscal;
			$scope.uploadAvailabilityDriver = uploadAvailabilityDriver;
			$scope.activeInfo = activeInfo;
			$scope.cancelInfo = cancelInfo;
			$scope.clickOutInfo = clickOutInfo;
			$scope.submitInfo = submitInfo;
			$scope.activePicture = activePicture;
			$scope.cancelPicture = cancelPicture;
			$scope.clickOutPicture = clickOutPicture;
			$scope.submitPicture = submitPicture;
			$scope.selectInvoice = selectInvoice;
			$scope.checkPhone = checkPhone;
			$scope.checkImage = checkImage;

			$scope.$watch('form.picture.dropImage', function(newValue) {
				 if (newValue) {
					 $scope.checkImage("dropImage");
					 $scope.form.picture.image = {};
				 }
			 });
		});
})();
